<template>
    <div class="mt-10">
        <div
            @click="close()"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1"
        >
            <span class="material-symbols-outlined">close</span>
        </div>
        <div class="mb-1 m-2 mx-4 flex justify-between">
            <div class="text-lg font-extrabold mb-1 mx-2">{{ trans.floor_direction.direction_ttl }}</div>
        </div>
        <div class="h-screen pb-20">
            <div
                class="description"
                style="padding-top: 0px;"
            >
                <div class="mt-2 detail">
                    <div class="mx-2 my-2">
                        <div class="flex">
                            <div class="flex-1">
                                <label class="mb-2 flex items-center">
                                    <span
                                        class="badge bg-info border box-shadow-lg mx-2"
                                        style="background-color: #007fff;border: 3px solid;border-color: #dadada;height: 24px;"
                                    ></span>
                                    <input
                                        type="search"
                                        name="departure"
                                        :placeholder="trans.floor_direction.departure"
                                        class="input input-bordered input-md w-full departure-input"
                                        :style="focusOn == 'departure' ? inputBorderStyle.departure : ''"
                                        :value="focusOn == 'departure' && search ? search : departureName"
                                        @focus="handleFocus"
                                        @blur="handleBlur"
                                        @input="searchKeyword"
                                        @search="clearSearch"
                                        ref="departure"
                                    />
                                </label>
                                <label class="flex mb-2 items-center">
                                    <span
                                        class="badge bg-info border box-shadow-lg mx-2"
                                        style="background-color: #ff007f;border: 3px solid;border-color: #dadada;height: 24px;"
                                    ></span>
                                    <input
                                        type="search"
                                        name="destination"
                                        :placeholder="trans.floor_direction.destination"
                                        class="input input-bordered input-md w-full destination-input"
                                        :style="focusOn == 'destination' ? inputBorderStyle.destination : ''"
                                        :value="focusOn == 'destination' && search ? search : destinationName"
                                        @focus="handleFocus"
                                        @blur="handleBlur"
                                        @input="searchKeyword"
                                        @search="clearSearch"
                                        ref="destination"
                                    />
                                </label>
                            </div>
                            <div
                                class="self-center m-2"
                                @click="swap"
                            >
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="24"
                                        viewBox="0 -960 960 960"
                                        width="24"
                                    >
                                        <path
                                            d="M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z"
                                        />
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div class="mb-5">
                            <!--
                            <button class="btn btn-outline btn-primary btn-sm justify-start my-1 mx-1">
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="24"
                                        viewBox="0 -960 960 960"
                                        width="24"
                                    >
                                        <path
                                            d="M516-120 402-402 120-516v-56l720-268-268 720h-56Zm26-148 162-436-436 162 196 78 78 196Zm-78-196Z"
                                        />
                                    </svg>
                                </span>
                                <span class="mr-2">your Location</span>
                            </button>
                            -->
                            <div class="">
                                <div class="inline-flex w-full items-stretch justify-center gap-0 px-4 flex-row">
                                    <div
                                        @click="accessibility = false"
                                        class="btn btn-sm group grow rounded-none rounded-l-lg"
                                        :class="!accessibility ? 'btn-primary' : ''"
                                    >
                                        <span class="material-symbols-outlined notranslate fill-current mr-1">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                height="20px"
                                                viewBox="0 -960 960 960"
                                                width="20px"
                                            >
                                                <path
                                                    d="m280-40 112-564-72 28v136h-80v-188l202-86q14-6 29.5-7t29.5 4q14 5 26.5 14t20.5 23l40 64q26 42 70.5 69T760-520v80q-70 0-125-29t-94-74l-25 123 84 80v300h-80v-260l-84-64-72 324h-84Zm260-700q-33 0-56.5-23.5T460-820q0-33 23.5-56.5T540-900q33 0 56.5 23.5T620-820q0 33-23.5 56.5T540-740Z"
                                                />
                                            </svg>
                                        </span>
                                        {{ trans.floor_direction.direct }}
                                    </div>
                                    <div
                                        @click="accessibility = true"
                                        class="btn btn-sm group grow rounded-none rounded-r-lg"
                                        :class="accessibility ? 'btn-primary' : ''"
                                    >
                                        <span class="material-symbols-outlined notranslate fill-current mr-1">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                height="20px"
                                                viewBox="0 -960 960 960"
                                                width="20px"
                                            >
                                                <path
                                                    d="M320-80q-83 0-141.5-58.5T120-280q0-83 58.5-141.5T320-480v80q-50 0-85 35t-35 85q0 50 35 85t85 35q50 0 85-35t35-85h80q0 83-58.5 141.5T320-80Zm360-40v-200H440q-44 0-68-37.5t-6-78.5l74-164h-91l-24 62-77-22 28-72q9-23 29.5-35.5T350-680h208q45 0 68.5 36.5T632-566l-66 146h114q33 0 56.5 23.5T760-340v220h-80Zm-40-580q-33 0-56.5-23.5T560-780q0-33 23.5-56.5T640-860q33 0 56.5 23.5T720-780q0 33-23.5 56.5T640-700Z"
                                                />
                                            </svg>
                                        </span>
                                        {{ trans.floor_direction.accessible }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden sm:block">
                            <div class="grid grow grid-cols-2 gap-2 my-3">
                                <div
                                    class="btn"
                                    @click="!isDisablePrevButton ? nextCameraStep(-1) : ''"
                                    :class="[isDisablePrevButton ? 'btn-disabled' : 'btn-neutral']"
                                    v-show="paths.length >= 1"
                                >{{ trans.floor_direction.previous }}</div>
                                <div
                                    class="btn"
                                    @click="!isDisableNextButton ? nextCameraStep(1) : ''"
                                    :class="[isDisableNextButton ? 'btn-disabled' : 'btn-neutral']"
                                    v-show="paths.length >= 1"
                                >{{ trans.floor_direction.next }}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex items-center p-3 guide relative justify-between"
                        :class="focusOn == 'departure' ? 'departure-guide' : 'destination-guide'"
                        v-show="focusOn"
                    >
                        <div class="flex items-center">
                            <span
                                class="mr-2 badge bg-info border border-blue-500 shadow-lg mx-2 w-fit"
                                :class="focusOn == 'departure' ? 'departure-circle' : 'destination-circle'"
                            ></span>
                            <span class="text-white text-sm">
                                {{ focusOn == 'departure' ? trans.floor_direction.please_select_departure :
                                    trans.floor_direction.please_select_destination }}
                            </span>
                        </div>
                        <div
                            tabindex="0"
                            role="button"
                            class="btn btn-sm btn-active px-1 btn-ghost text-base-100"
                            @click="handleClick"
                            :class="focusOn == 'departure' ? '' : 'hidden'"
                        >
                            <span class="material-symbols-outlined notranslate fill-current">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="24"
                                    viewBox="0 -960 960 960"
                                    width="24"
                                >
                                    <path
                                        d="M516-120 402-402 120-516v-56l720-268-268 720h-56Zm26-148 162-436-436 162 196 78 78 196Zm-78-196Z"
                                    ></path>
                                </svg>
                            </span>
                            <span
                                class="loading loading-spinner loading-sm ml-2"
                                v-if="isLoadingYourLocation"
                            ></span>
                        </div>
                    </div>
                    <hr class="my-0 mx-2" />
                    <div
                        class="menu top-0 z-10 bg-base-200 overflow-y-auto h-screen py-5 pb-20 floor-direction-content-height"
                        v-if="dropdownOpen && parcelResource.layers.length > 1"
                    >
                        <div class="flex flex-col justify-end">
                            <div>
                                <div
                                    tabindex="0"
                                    class="dropdown-content menu bg-base-100 rounded-box z-100 w-full p-3 shadow"
                                >
                                    <div class="flex justify-between">
                                        <div class="font-bold m-2 text-base">{{ this.trans.floor_direction.select_floor }}
                                        </div>
                                        <div
                                            @click="closeDropdown"
                                            class="btn btn-square btn-sm btn-ghost close-z-100"
                                        >
                                            <span class="material-symbols-outlined notranslate fill-current">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    height="24"
                                                    viewBox="0 -960 960 960"
                                                    width="24"
                                                >
                                                    <path
                                                        d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                                                    ></path>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        v-for="layer in parcelResource.layers"
                                        :key="`layer-radio-${layer.id}`"
                                        class="form-control"
                                        @click="chooseYourLocation"
                                    >
                                        <label class="label">
                                            <span class="label-text">{{ layer.title }}</span>
                                            <input
                                                type="radio"
                                                class="radio radio-primary"
                                                :value="layer.id"
                                                v-model="yourCurrentLayer"
                                            >
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <p
                                class="text-error mx-4"
                                v-if="yourLocationError"
                            >{{ yourLocationError }}</p>
                        </div>
                    </div>
                    <div class="menu top-0 z-10">
                        <div class="flex">
                            <div class="text-base-content text-base mx-2 font-extrabold">{{ parcelResource.title }}</div>
                        </div>
                    </div>
                    <div class="overflow-y-auto h-screen py-0 pb-20 floor-direction-content-height">
                        <table class="table menu overflow-visible p-0 floor-content-height">
                            <tbody
                                class="relative"
                                v-for="layer in parcelResource.layers"
                                :key="'layer-key-' + layer.id"
                            >
                                <div
                                    class="menu sticky top-0 z-10 bg-base-200 space-x-2"
                                    style="border-left: solid 7px; border-bottom: solid 1px;"
                                >
                                    <div class="flex p-0 items-center">
                                        <div class="btn btn-neutral btn-xs w-10">{{ layer.shortened_title
                                        }}</div>
                                        <div class="px-2 py-2 block">
                                            <div class="font-bold">{{ layer.title }}</div>
                                            <!-- <span
                                                class="material-symbols-outlined"
                                            >wc</span>-->
                                        </div>
                                    </div>
                                </div>
                                <tr
                                    v-for="location in getLocationsByLayerId(layer.id)"
                                    :key="'location-list-by-layer-' + location.properties.id"
                                    @click="choose(location.properties.id)"
                                    class="w-full hover inline-block"
                                >
                                    <td class="flex items-center space-x-2">
                                        <div class>
                                            <div class="mask mask-squircle bg-base-content h-16 w-16 bg-opacity-10 p-px">
                                                <img
                                                    :class="[location.properties.marker_style === 'icon' || location.properties.marker_style === 'point' ? 'bg-primary' : 'bg-base-100']"
                                                    class="mask mask-squircle w-full h-full object-cover bg-base-100"
                                                    :src="location.properties.marker_image_url"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div class="text-base font-bold">{{ location.properties.title }}</div>
                                            <div class="text-base-content/70 text-sm">{{ location.properties.sub_title }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <template v-for="otherParcel in relatedParcels">
                                <tbody
                                    class="relative"
                                    v-for="layer in otherParcel.layers"
                                    :key="'layer-key' + layer.id"
                                    v-show="!parcelResource.layers.some(el => el.id == layer.id)"
                                >
                                    <div
                                        class="menu sticky top-0 z-10 bg-base-200 space-x-2"
                                        style="border-left: solid 7px; border-bottom: solid 1px;"
                                    >
                                        <div class="flex p-0 items-center">
                                            <div class="btn btn-secondary btn-xs w-10">{{ layer.shortened_title
                                            }}</div>
                                            <div class="px-2 py-2 block">
                                                <div class="font-bold">{{ otherParcel.title }} - {{ layer.title }}</div>
                                                <!-- <span
                                                    class="material-symbols-outlined"
                                                >wc</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <tr
                                        v-for="location in getLocationsByLayerId(layer.id)"
                                        :key="'location-list-by-layer-' + location.properties.id"
                                        @click="choose(location.properties.id)"
                                        class="w-full hover inline-block"
                                    >
                                        <td class="flex items-center space-x-2">
                                            <div class>
                                                <div
                                                    class="mask mask-squircle bg-base-content h-16 w-16 bg-opacity-10 p-px">
                                                    <img
                                                        :class="[location.properties.marker_style === 'icon' || location.properties.marker_style === 'point' ? 'bg-primary' : 'bg-base-100']"
                                                        class="mask mask-squircle w-full h-full object-cover bg-base-100"
                                                        :src="location.properties.marker_image_url"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-base font-bold">{{ location.properties.title }}</div>
                                                <div class="text-base-content/70 text-sm">{{ location.properties.sub_title
                                                }}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Graph from "../lib/Graph";
import * as turf from "@turf/turf";
import mapboxgl from 'mapbox-gl';
import maplibregl from "maplibre-gl";

const NODE_PATH = 1;
const NODE_TRANSITION = 2;
const NODE_LOCATION = 3;
const PARCEL_TRANSITION = 4;

export default {
    inject: ['trans', 'locale'],
    props: {
        parcelResource: {
            type: Object,
            required: true,
        },
        locationResource: {
            type: Array,
            required: true,
        },
        facilityResource: {
            type: Array,
            required: true,
        },
        mySmartMap: {
            type: Object,
            required: true,
        },
        currentLayer: {
            type: Object,
            required: true,
        },
        useMaplibre: {
            type: Boolean,
            default: false
        },
        onMoveend: {
            type: Function,
            required: true,
        },
        status: {
            type: Boolean,
            required: true
        },
        geolocateControl: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            from: "",
            to: "",
            accessibility: false,
            nodes: [],
            links: [],
            graph: {},
            paths: [],
            nextPathIndex: 0,
            cameraStep: 0,
            reqAnimationId: 0,
            transMarkers: [],
            startingMarker: "",
            endingMarker: "",
            focusOn: "",
            search: "",
            blurTimeout: null,
            inputBorderStyle: {
                departure: "",
                destination: ""
            },
            relatedParcels: [],
            relatedLocations: [],
            relatedLayers: [],
            distance: 0,
            yourCurrentLayer: this.currentLayer.id,
            yourLocation: "",
            isLoadingYourLocation: false,
            yourLocationError: "",
            dropdownOpen: false,
            isOutOfMaxbounds: false
        };
    },
    computed: {
        departureName() {
            if (this.from?.name == 'your_location') {
                return "Your location"
            }
            return this.from
                ? this.relatedLocations.find(
                    (el) => el.properties.id == this.from.location_id
                ).properties.title
                : "";
        },
        destinationName() {
            if (this.to?.name == 'your_location') {
                return "Your location"
            }
            return this.to
                ? this.relatedLocations.find(
                    (el) => el.properties.id == this.to.location_id
                ).properties.title
                : "";
        },
        isMobileScreen() {
            return window.screen.width <= 640;
        },
        isDisableNextButton() {
            return this.nextPathIndex == this.paths.length - 1 && this.cameraStep == 3;
        },
        isDisablePrevButton() {
            return this.nextPathIndex == 0 && this.cameraStep == 1;
        },
        paddingOptions() {
            if (this.isMobileScreen) {
                return 20
            }

            return { top: 100, bottom: 100, left: 600, right: 200 };
        },
        zoomTo() {
            let zoom = this.parcelResource.zoom_level + 2 > 22 ? 22 : this.parcelResource.zoom_level + 2;
            return this.parcelResource.zoom_level > 16 ? zoom : 16;
        },
        reducedLocations() {
            var locationIds = [];
            const isApplySearch = this.focusOn && this.search;
            this.nodes.forEach(el => {
                if (el.type == NODE_LOCATION && el.location_id && [this.from?.location_id, this.to?.location_id].includes(el.location_id) == false) {
                    locationIds.push(el.location_id);
                }
            });

            return this.relatedLocations.filter(el => locationIds.includes(el.properties.id) && (!isApplySearch || el.properties.title.includes(this.search)));
        },
        roundedDistance() {
            // km to m
            return Math.round(this.distance * 100) * 1000 / 100;
        },
        roundedTime() {
            // minutes
            return Math.round(this.roundedDistance * 1.2 / 60 * 100) / 100;
        },
        departureIsOnOtherParcels() {
            if (this.parcelResource.layers.some(l => l.id == this.from.layer_id)) {
                return false;
            }
            return this.relatedParcels.some(el => el.layers.some(l => l.id == this.from.layer_id));
        }
    },
    created() {
        axios
            .get(`/api/parcels/${this.parcelResource.id}/graph/${this.locale}`)
            .then((response) => {
                this.nodes = response.data.nodes;
                this.links = response.data.links;
                this.relatedParcels = response.data.relatedParcels;
                this.relatedLocations = response.data.relatedLocations;
                this.relatedLayers = response.data.relatedLayers;
                this.graph = new Graph(this.nodes.length + 2);
                this.addEdges();
                this.addVertexes();
            });
    },
    methods: {
        isHasParamPathsOnURL() {
            const params = new URLSearchParams(window.location.search);
            const paths = params.get("paths");

            return paths ? true : false;
        },
        getLocationsByLayerId(layerId) {
            return this.reducedLocations.filter(el => el.properties.layer_id == layerId);
        },
        addEdges() {
            this.links.forEach((link) => {
                let sourceIndex = this.nodes.findIndex(
                    (node) => node.id == link.source
                );
                let targetIndex = this.nodes.findIndex(
                    (node) => node.id == link.target
                );
                let weight = parseFloat(link.distance) + parseFloat(link.weight);
                if (sourceIndex != -1 && targetIndex != -1) {

                    this.graph.addEdge(
                        sourceIndex,
                        targetIndex,
                        weight,
                        link.is_one_way
                    );
                    this.graph.addAccessibility(
                        sourceIndex,
                        targetIndex,
                        link.accessibility
                    );
                }
            });
        },
        addVertexes() {
            this.nodes.forEach((node, index) => {
                this.graph.addVertexData(index, node.id);
            });
        },
        findPath(start, end, accessibility) {
            this.clearYourLocationNodes();
            const [distances, predecessors] = this.graph.dijkstra(
                start.id,
                accessibility
            );
            this.distance = distances[this.graph.vertexData.indexOf(end.id)];
            const path = this.graph.getPath(predecessors, start.id, end.id);
            var layerId = "";
            var coordinates = [];
            var tempPaths = [];
            var nodeIds = [];
            for (let i = 0; i < path.length; i++) {
                var nodeId = path[i];
                nodeIds.push(nodeId);
                const node = this.nodes.find(el => el.id == nodeId);
                coordinates.push(node.coordinates);

                if (i == 0) {
                    layerId = node.layer_id;
                    continue;
                } else if (i == path.length - 1) {
                    tempPaths.push({
                        layer_id: layerId,
                        coordinates: coordinates,
                        node_ids: nodeIds
                    });
                    break;
                }

                if (node.type != NODE_TRANSITION && node.type != PARCEL_TRANSITION) {
                    continue;
                }


                tempPaths.push({
                    layer_id: layerId,
                    coordinates: coordinates,
                    node_ids: nodeIds
                })

                i += 1;
                const nextNode = this.nodes.find(el => el.id == path[i]);
                layerId = nextNode.layer_id;
                coordinates = [nextNode.coordinates];
                nodeIds = [nextNode.id];
            }
            this.paths = tempPaths;
            if (this.paths.length == 0) {
                alert("Path not found");
                return;
            }

            this.nextPathIndex = this.isHasParamPathsOnURL() ? this.nextPathIndex : 0;
            if (this.departureIsOnOtherParcels && !this.isHasParamPathsOnURL()) {
                let parcel = this.relatedParcels.find(el => el.layers.some(l => l.id == start.layer_id));
                this.goToNextParcel(parcel, this.nextPathIndex);
                return
            }
            this.drawPath();
        },
        showShortestPathLayers() {
            this.mySmartMap.setLayoutProperty(
                "shortest-path-bg",
                "visibility",
                "visible"
            );
            this.mySmartMap.setLayoutProperty(
                "tp-shortest-path",
                "visibility",
                "visible"
            );
        },
        hideShortestPathLayers() {
            this.mySmartMap.setLayoutProperty(
                "shortest-path-bg",
                "visibility",
                "none"
            );
            this.mySmartMap.setLayoutProperty(
                "tp-shortest-path",
                "visibility",
                "none"
            );
        },
        startAnimate() {
            var self = this;
            let startTime;
            let stopAnimation = false;

            const frame = (time) => {
                if (!startTime) {
                    startTime = time;
                }
                const animationPhase = (time - startTime) / 800;
                // Reduce the visible length of the line by using a line-gradient to cutoff the line
                // animationPhase is a value between 0 and 1 that represents the progress of the animation
                if (!stopAnimation) {
                    self.mySmartMap.setPaintProperty("tp-shortest-path",
                        'line-gradient', [
                        "interpolate",
                        ["linear"],
                        ["line-progress"],
                        animationPhase - 0.15, "rgba(0, 0, 0, 0)", // Transparent before the moving line
                        animationPhase, "#fff", // Start of the moving line
                        animationPhase + 0.15, "rgba(0, 0, 0, 0)" // Transparent after the moving line
                    ]);
                }
                if (animationPhase > 1) {
                    stopAnimation = true;
                }

                if (time >= startTime + 2800) {
                    startTime = undefined;
                    stopAnimation = false;
                }

                self.reqAnimationId = requestAnimationFrame(frame);
            };

            this.reqAnimationId = requestAnimationFrame(frame);
        },
        stopAnimate() {
            if (this.reqAnimationId) {
                cancelAnimationFrame(this.reqAnimationId);
            }
        },
        nextPath() {
            var self = this;

            if (this.nextPathIndex == this.paths.length - 1) {
                return;
            }
            this.stopAnimate();
            this.hideShortestPathLayers();

            this.nextPathIndex += 1;
            let layerId = this.paths[this.nextPathIndex].layer_id;
            var parcel = this.relatedParcels.find(el => el.layers.some(l => l.id == layerId));
            if (parcel.id != this.parcelResource.id) {
                this.goToNextParcel(parcel, this.nextPathIndex);
                return;
            }
            this.$emit(
                "changedLayerId",
                layerId
            );
            this.$nextTick(() => {
                self.showShortestPathLayers();
                self.drawPath();
            })
        },
        prevPath() {
            var self = this;
            if (this.nextPathIndex == 0) {
                return;
            }

            this.stopAnimate();
            this.hideShortestPathLayers();
            this.nextPathIndex -= 1;
            let layerId = this.paths[this.nextPathIndex].layer_id;
            var parcel = this.relatedParcels.find(el => el.layers.some(l => l.id == layerId));
            if (parcel.id != this.parcelResource.id) {
                this.goToNextParcel(parcel, this.nextPathIndex);
                return;
            }
            this.$emit(
                "changedLayerId",
                layerId
            );
            this.$nextTick(() => {
                self.showShortestPathLayers();
                self.drawPath();
            })
        },
        goToNextParcel(parcel, nextPathIndex) {
            const regex = /\/parcels\/\d+/g;
            var encodedPaths = encodeURIComponent(JSON.stringify(this.paths));
            let url =
                window.location.pathname.replace(regex, '/parcels/' + parcel.id) + "?openFloorDirection=true" + "&paths=" + encodedPaths + "&nextPathIndex=" + nextPathIndex + "&from=" + JSON.stringify(this.from) + "&to=" + JSON.stringify(this.to) + "&accessibility=" + this.accessibility;
            window.location.replace(
                url,
            );
        },
        nextCameraStep(next) {
            this.cameraStep = this.cameraStep + next;
            if (this.cameraStep == 4) {
                this.cameraStep = 0;
            }
            const coordinates = this.paths[this.nextPathIndex].coordinates;

            switch (this.cameraStep) {
                case 0:
                    if (next == 1) {
                        this.nextPath();
                    } else {
                        this.prevPath();
                    }
                    break;
                case 1:
                    this.mySmartMap.flyTo({ center: coordinates[0], zoom: this.zoomTo });
                    break;

                case 2:
                    const lineString = turf.lineString(coordinates);
                    var bbox = turf.bbox(lineString);
                    const newCameraTransform = this.mySmartMap.cameraForBounds(bbox, {
                        padding: this.paddingOptions,
                    });

                    this.mySmartMap.flyTo(newCameraTransform);
                    break;

                case 3:
                    this.mySmartMap.flyTo({ center: coordinates[coordinates.length - 1], zoom: this.zoomTo });
                    break;
            }
        },
        drawPath() {
            if (this.startingMarker) this.startingMarker.remove();
            if (this.endingMarker) this.endingMarker.remove();
            this.removeTransMarkers();
            this.cameraStep = 1;

            const coordinates = this.paths[this.nextPathIndex].coordinates;
            const lineString = turf.lineString(coordinates);
            const nodeIds = this.paths[this.nextPathIndex].node_ids;

            // Set the start and end points of the line as separate features
            const startPoint = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: coordinates[0]
                },
                properties: {
                    order: this.nextPathIndex == 0 ? 'start' : 'floorChangeFrom',
                    node_id: nodeIds[0]
                }
            };

            const endPoint = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: coordinates[coordinates.length - 1]
                },
                properties: {
                    order: this.nextPathIndex == this.paths.length - 1 ? 'end' : 'floorChangeTo', // 終了点を示すプロパティ,
                    node_id: nodeIds[nodeIds.length - 1]
                }
            };
            if (startPoint.properties.order == "floorChangeFrom") {
                this.createTransNodeBtn(startPoint);
            } else {
                this.createStartingPoint(startPoint);
            }
            if (endPoint.properties.order == "floorChangeTo") {
                this.createTransNodeBtn(endPoint);
            } else {
                this.createEndingPoint(endPoint);
            }
            this.mySmartMap.getSource("shortest-path").setData({
                type: "FeatureCollection",
                features: [lineString, startPoint, endPoint],
            });

            this.startAnimate();

            this.mySmartMap.moveLayer("shortest-path-bg");
            this.mySmartMap.moveLayer("tp-shortest-path");
            this.mySmartMap.moveLayer("line-points");

            this.mySmartMap.flyTo({ center: coordinates[0], zoom: this.zoomTo });
        },
        choose(locationId) {
            if (this.blurTimeout) {
                clearTimeout(this.blurTimeout);
                this.blurTimeout = null;
            }
            if ((!this.focusOn && !this.from) || this.focusOn == 'departure') {
                this.from = this.nodes.find(
                    (el) => el.location_id == locationId
                );
            } else {
                this.to = this.nodes.find((el) => el.location_id == locationId);
            }
            if (!this.to) {
                this.$refs.destination.focus();
            } else {
                this.$refs.departure.focus();
            }
        },
        chooseDestination(locationId) {
            this.to = this.nodes.find((el) => el.location_id == locationId);
            setTimeout(() => {
                this.$refs.departure.focus();
            }, 850);
        },
        close() {
            this.stopAnimate();
            this.mySmartMap.getSource("shortest-path").setData({
                type: "FeatureCollection",
                features: [],
            });
            this.from = "";
            this.to = "";
            this.paths = [];
            window.history.replaceState(null, '', window.location.pathname);
            this.$emit("closed");
        },
        swap() {
            let from = this.from;
            let to = this.to;
            this.clearPath();
            this.from = to;
            this.to = from;
        },
        createTransNodeBtn(point) {
            const index = point.properties.order == "floorChangeTo" ? 1 : 0;
            let nextPathIndex = index == 1 ? this.nextPathIndex + 1 : this.nextPathIndex - 1;

            let layerId = this.paths[nextPathIndex].layer_id
            const layer = this.relatedLayers.find(el => el.id == layerId);

            let node = this.nodes.find(el => el.id == point.properties.node_id);
            let facilityImg = this.facilityResource.find(el => el.id == node.facility_id)?.image_url;
            let facilityImgHTML = facilityImg ? `<img src="${facilityImg}" style="max-width:2rem;">` : "";

            var div = document.createElement('div');
            const btn = index ? "btn-trans-from" : "btn-trans-to";
            const directionTextFront = index ? this.trans.floor_direction.go_to_front : this.trans.floor_direction.back_to_front;
            const directionTextEnd = index ? this.trans.floor_direction.go_to_end : this.trans.floor_direction.back_to_end;
            div.className = `btn ${btn} normal-case btn-base rounded-full text-white opacity-90 trans-node`;
            div.innerHTML = `<div class="flex ml-2 mr-2 items-center">
                <span class="ml-2 mr-2">${facilityImgHTML} </span>
                <span>${directionTextFront} ${layer.shortened_title} ${directionTextEnd}</span>
            </div>
            <svg
                class="h-4 w-4 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
            >
                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
            </svg>`;
            const el = document.createElement('div');
            el.appendChild(div);
            el.style.top = '-30px';
            el.style.left = '40px';
            el.addEventListener('click', () => {
                if (index) {
                    this.nextPath();
                } else {
                    this.prevPath();
                }
            });

            this.transMarkers[index] = this.useMaplibre
                ? new maplibregl.Marker(el).setLngLat(point.geometry.coordinates).addTo(this.mySmartMap)
                : new mapboxgl.Marker(el).setLngLat(point.geometry.coordinates).addTo(this.mySmartMap);
        },
        createStartingPoint(point) {
            var div = document.createElement('div');
            div.className = 'map-button';
            div.innerHTML = `<div class="tooltip tooltip-open tooltip-bottom" data-tip="${this.roundedTime} ${this.trans.floor_direction.minutes} ( ${this.roundedDistance} m )"><div class="btn btn-sm rounded-full text-white btn-sm start-point w-max">${this.trans.floor_direction.start.toUpperCase()}</div></div>`
            const el = document.createElement('div');
            el.appendChild(div);
            el.style.top = '30px';
            el.addEventListener('click', this.clearPath);

            this.startingMarker = this.useMaplibre
                ? new maplibregl.Marker(el).setLngLat(point.geometry.coordinates).addTo(this.mySmartMap)
                : new mapboxgl.Marker(el).setLngLat(point.geometry.coordinates).addTo(this.mySmartMap);
        },
        createEndingPoint(point) {
            var div = document.createElement('div');
            div.className = 'map-button';
            div.innerHTML = `<div class="btn btn-sm rounded-full text-white btn-sm end-point w-max">${this.trans.floor_direction.end.toUpperCase()}</div>`
            const el = document.createElement('div');
            el.appendChild(div);
            el.style.top = '30px';
            el.addEventListener('click', this.clearPath);

            this.endingMarker = this.useMaplibre
                ? new maplibregl.Marker(el).setLngLat(point.geometry.coordinates).addTo(this.mySmartMap)
                : new mapboxgl.Marker(el).setLngLat(point.geometry.coordinates).addTo(this.mySmartMap);
        },
        searchKeyword(e) {
            this.search = e.target.value;
            if (e.target.value != '') return;

            if (this.focusOn == 'departure') {
                this.from = '';
            } else {
                this.to = '';
            }
        },
        hideMarkers() {
            const markers = document.getElementsByClassName('mapboxgl-marker');
            const pattern = new RegExp("^spot-(?!(?:" + this.from.location_id + "|" + this.to.location_id + ")$)\\d+$");

            for (let i = 0; i < markers.length; i++) {
                const marker = markers[i];
                marker.style.display = pattern.test(marker.id) ? "none" : "block";
            }
        },
        showMarkers() {
            const markers = document.getElementsByClassName('mapboxgl-marker');

            for (let i = 0; i < markers.length; i++) {
                const marker = markers[i];
                marker.style.display = "block";
            }
        },
        clearSearch() {
            this.search = '';
            if (this.focusOn == 'departure') {
                this.from = '';
            } else {
                this.to = '';
            }
        },
        clearPath() {
            if (this.isHasParamPathsOnURL()) {
                window.history.replaceState(null, '', window.location.pathname);
            }
            this.stopAnimate();
            this.mySmartMap.getSource("shortest-path").setData({
                type: "FeatureCollection",
                features: [],
            });
            this.to = "";
            this.paths = [];
        },
        handleBlur() {
            this.blurTimeout = setTimeout(() => {
                if (this.focusOn == 'destination') {
                    this.inputBorderStyle.destination = 'border-color: #ff007f;';
                } else if (this.focusOn == 'departure') {
                    this.inputBorderStyle.departure = 'border-color: #007fff;';
                }
            }, 100);
        },
        handleFocus(e) {
            if (this.blurTimeout) {
                clearTimeout(this.blurTimeout);
                this.blurTimeout = null;
            }
            this.focusOn = e.srcElement.name;
            this.inputBorderStyle = {
                destination: "",
                departure: ""
            }
        },
        removeTransMarkers() {
            this.transMarkers.forEach(el => el.remove());
        },
        initFromURLParams() {
            const params = new URLSearchParams(window.location.search);
            const paths = params.get("paths");
            const nextPathIndex = params.get("nextPathIndex");
            const from = params.get("from");
            const to = params.get("to");
            if (!paths) {
                return;
            }
            var decodedPaths = JSON.parse(decodeURIComponent(paths));
            if (nextPathIndex < 0 || nextPathIndex >= decodedPaths.length) {
                console.error("Wrong params");
                return;
            }

            this.paths = decodedPaths;
            this.from = JSON.parse(from);
            this.to = JSON.parse(to);
            this.nextPathIndex = parseInt(nextPathIndex);
            this.accessibility = params.get("accessibility") == 'true' ? true : false;
        },
        initDefaultSpot() {
            if (this.isHasParamPathsOnURL()) {
                return;
            }

            var nodeLen = this.nodes.length;
            for (let i = 0; i < nodeLen; i++) {
                const node = this.nodes[i];
                if (!node.default_spot_type) continue;

                if (node.default_spot_type == 1) {
                    this.from = node;
                } else {
                    this.to = node;
                }
                break;
            }
        },
        getCurrentLocation() {
            if (this.isOutOfMaxbounds) {
                this.$emit('outofmaxbounds');
                return;
            }
            this.yourLocationError = "";
            this.isLoadingYourLocation = true;
            var self = this;

            this.geolocateControl.trigger();
            this.geolocateControl.once('geolocate', (e) => {
                var lon = e.coords.longitude;
                var lat = e.coords.latitude
                var position = [lon, lat];
                self.addYourLocationIntoNodes(position);
                self.isLoadingYourLocation = false;
            });
            this.geolocateControl.once('outofmaxbounds', () => {
                self.isOutOfMaxbounds = true;
                self.isLoadingYourLocation = false;
                self.yourLocationError = "Can not get your current location";
                self.$emit('outofmaxbounds');
                return;
            });
            this.geolocateControl.once('error', () => {
                self.isLoadingYourLocation = false;
                self.yourLocationError = "Can not get your current location";
                console.log('An error event has occurred.');
            });
        },
        addYourLocationIntoNodes(yourLocationCoord) {
            const maxNodeId = Math.max(...this.nodes.map(o => o.id));
            var layerNodes = this.nodes.filter(el => el.layer_id == this.yourCurrentLayer);
            var nodeIds = layerNodes.map(n => n.id);
            var links = this.links.filter(el => nodeIds.includes(el.source) && nodeIds.includes(el.target));
            var yourLocationPt = turf.point(yourLocationCoord);
            var min = 0;
            var link, pointOnLine;
            links.forEach(l => {
                let source = this.nodes.find(el => el.id == l.source);
                let target = this.nodes.find(el => el.id == l.target);
                let line = turf.lineString([source.coordinates, target.coordinates]);
                var nearestPt = turf.nearestPointOnLine(line, yourLocationPt);
                var distance = turf.distance(yourLocationPt, nearestPt);
                if (min == 0 || distance < min) {
                    min = distance;
                    link = l;
                    pointOnLine = {
                        coordinates: nearestPt.geometry.coordinates,
                        pt1: source,
                        pt2: target
                    };
                }
            });

            var yourLocationIndex = this.nodes.findIndex(el => el.name == 'your_location');
            if (yourLocationIndex == -1) {
                this.nodes.push({
                    id: maxNodeId + 1,
                    name: 'your_location',
                    coordinates: yourLocationCoord,
                    layer_id: this.yourCurrentLayer,
                    type: NODE_PATH
                });
                yourLocationIndex = this.nodes.length - 1;
            } else {
                this.nodes[yourLocationIndex].coordinates = yourLocationCoord;
            }

            var nearestIndex = this.nodes.findIndex(el => el.name == 'nearest');
            if (nearestIndex == -1) {
                this.nodes.push({
                    id: maxNodeId + 2,
                    name: 'nearest',
                    coordinates: pointOnLine.coordinates,
                    layer_id: this.yourCurrentLayer,
                    type: NODE_PATH
                });
                nearestIndex = this.nodes.length - 1;
            } else {
                this.nodes[nearestIndex].coordinates = pointOnLine.coordinates;
            }

            const yourLocationNode = this.nodes[yourLocationIndex];
            const nearestNode = this.nodes[nearestIndex];
            this.graph.addVertexData(yourLocationIndex, yourLocationNode.id);
            this.graph.addVertexData(nearestIndex, nearestNode.id);

            let yourLocationToNearest = turf.distance(yourLocationNode.coordinates, nearestNode.coordinates);
            this.graph.addEdge(
                yourLocationIndex,
                nearestIndex,
                yourLocationToNearest
            );
            this.graph.addAccessibility(
                yourLocationIndex,
                nearestIndex,
                1
            );

            let pt1Index = this.nodes.findIndex(el => el.id == pointOnLine.pt1.id);
            let pt2Index = this.nodes.findIndex(el => el.id == pointOnLine.pt2.id);
            let nearestToPt1 = turf.distance(nearestNode.coordinates, pointOnLine.pt1.coordinates);
            let nearestToPt2 = turf.distance(nearestNode.coordinates, pointOnLine.pt2.coordinates);
            this.graph.addEdge(pt1Index, nearestIndex, nearestToPt1);
            this.graph.addEdge(pt2Index, nearestIndex, nearestToPt2);
            this.graph.addAccessibility(
                pt1Index,
                nearestIndex,
                1
            );
            this.graph.addAccessibility(
                pt2Index,
                nearestIndex,
                1
            );

            if (this.focusOn == 'departure') {
                this.from = yourLocationNode;
            } else {
                this.to = yourLocationNode;
            }
        },
        chooseYourLocation() {
            this.getCurrentLocation();
            this.dropdownOpen = false;
        },
        clearYourLocationNodes() {
            if ((this.from.name == 'your_location' || this.to.name == 'your_location') || !this.nodes.some(el => el.name == 'your_location')) {
                return;
            }
            var newNodes = [];
            var yourLocationNode, nearestNode;
            for (let i = 0; i < this.nodes.length; i++) {
                const node = this.nodes[i];
                if (node.name == 'your_location') {
                    yourLocationNode = node;
                } else if (node.name == 'nearest') {
                    nearestNode = node;
                } else {
                    newNodes.push(node);
                }
            }
            this.nodes = newNodes;

            var newLinks = [];
            var removeIds = [yourLocationNode.id, nearestNode.id];
            for (let i = 0; i < this.links.length; i++) {
                const link = this.links[i];
                if (removeIds.includes(link.source) || removeIds.includes(link.target)) {
                    continue;
                }
                newLinks.push(link);
            }
            this.links = newLinks;

            this.graph = new Graph(this.nodes.length + 2);
            this.addEdges();
            this.addVertexes();
        },
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        closeDropdown() {
            this.dropdownOpen = false;
        },
        handleClick() {
            if (this.parcelResource.layers.length === 1) {
                this.yourCurrentLayer = this.parcelResource.layers[0].id;
                this.chooseYourLocation();
            } else {
                this.toggleDropdown();
            }
        }
    },
    mounted() {
        var self = this;
        this.mySmartMap.on("load", () => {
            self.mySmartMap.addSource("shortest-path", {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: [],
                },
                lineMetrics: true
            });
            self.mySmartMap.addLayer({
                id: "shortest-path-bg",
                type: "line",
                source: "shortest-path",
                paint: {
                    "line-color": "#fff",
                    "line-width": 12,
                    "line-opacity": 1,
                    'line-gradient': [
                        'interpolate',
                        ['linear'],
                        ['line-progress'],
                        0, '#00FFFF',
                        0.5, '#8000ff',
                        1, '#ff007f'
                    ]
                }
            });
            self.mySmartMap.addLayer({
                type: "line",
                source: "shortest-path",
                id: "tp-shortest-path",
                paint: {
                    "line-color": "rgba(0,0,0,0)",
                    "line-width": 15,
                    "line-opacity": 1
                }
            });
            // Add circles at the start and end points
            self.mySmartMap.addLayer({
                id: 'line-points',
                type: 'circle',
                source: "shortest-path",
                paint: {
                    'circle-radius': 12,
                    'circle-stroke-width': 3,
                    'circle-stroke-color': [
                        'case',
                        ['==', ['geometry-type'], 'Point'], // 開始点と終了点のフィルター
                        ['case', ['==', ['get', 'order'], 'start'], '#fff', '#fff'], // 開始点と終了点のボーダー色は白
                        '#000' // その他のポイントのボーダー色は黒
                    ],
                    'circle-color': [
                        'case',
                        ['==', ['geometry-type'], 'Point'], // 開始点と終了点のフィルター
                        ['case',
                            ['==', ['get', 'order'], 'start'], '#007fff',
                            ['==', ['get', 'order'], 'floorChangeFrom'], '#7c7c7c',
                            ['==', ['get', 'order'], 'floorChangeTo'], '#7c7c7c',
                            '#ff007f' // 終了点は赤
                        ],
                        '#FF0' // その他のポイントの色
                    ]
                },
                filter: ['in', '$type', 'Point']
            });
            self.initFromURLParams();
        });
    },
    watch: {
        from(newVal) {
            if (!newVal || !this.to) {
                return;
            }

            const isChangeLayer = (newVal.layer_id != this.currentLayer.id) && !this.departureIsOnOtherParcels;
            if (isChangeLayer) {
                this.$emit('changedLayerId', newVal.layer_id);
            }

            this.stopAnimate();
            if (isChangeLayer) {
                this.mySmartMap.once('idle', () => {
                    this.findPath(newVal, this.to, this.accessibility);
                    if (this.isMobileScreen) {
                        this.$emit('hideFloorDirection');
                    }
                });
            } else {
                this.findPath(newVal, this.to, this.accessibility);
                if (this.isMobileScreen) {
                    this.$emit('hideFloorDirection');
                }
            }
        },
        to(newVal) {
            if (!newVal || !this.from) {
                return;
            }

            this.stopAnimate();
            this.findPath(this.from, newVal, this.accessibility);
            if (this.isMobileScreen) {
                this.$emit('hideFloorDirection');
            }
        },
        accessibility(newVal) {
            if (!this.from || !this.to) {
                return;
            }
            this.paths = [];
            this.stopAnimate();
            this.findPath(this.from, this.to, newVal);
            if (this.isMobileScreen) {
                this.$emit('hideFloorDirection');
            }
        },
        paths(newVal) {
            if (newVal.length <= 1 && this.transMarkers.length > 0) {
                this.removeTransMarkers();
            }
            if (newVal.length == 0) {
                this.showMarkers();
                this.mySmartMap.off('render', this.hideMarkers);
                this.mySmartMap.on('moveend', this.onMoveend);
                this.onMoveend();
                if (this.startingMarker) this.startingMarker.remove();
                if (this.endingMarker) this.endingMarker.remove();
            } else {
                this.mySmartMap.off('moveend', this.onMoveend);
                this.mySmartMap.on('render', this.hideMarkers);
                this.hideMarkers();
            }
        },
        focusOn(newVal) {
            if (!newVal) {
                this.search = "";
                return;
            }
        },
        status(newVal, oldVal) {
            if (newVal && !oldVal) {
                this.$refs.destination.focus();
            }
            this.initDefaultSpot();
        }
    },
};
</script>

<style>
.floor-content-height {
    padding-bottom: 25rem;
}

.floor-direction-content-height {
    padding-bottom: 41rem;
}

.trans-node {
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
}

input.departure-input:focus {
    outline-color: #007fff;
}

input.destination-input:focus {
    outline-color: #ff007f;
}

.departure-circle {
    background-color: #007fff;
    border: 3px solid;
    border-color: #dadada;
    height: 24px;
}

.destination-circle {
    background-color: #ff007f;
    border: 3px solid;
    border-color: #dadada;
    height: 24px;
}

.departure-guide {
    background-color: rgba(0, 127, 255, 0.9);
}

.destination-guide {
    background-color: rgba(255, 0, 127, 0.9);
}

.departure-guide:after {
    content: '';
    position: absolute;
    border: 6px solid rgba(0, 127, 255, 0.9);
    border-color: rgba(0, 127, 255, 0.9) transparent transparent;
    width: 0;
    height: 0;
    bottom: -12px;
    left: 50%;
    margin-left: -6px;
}

.destination-guide:after {
    content: '';
    position: absolute;
    border: 6px solid rgba(255, 0, 127, 0.9);
    border-color: rgba(255, 0, 127, 0.9) transparent transparent;
    width: 0;
    height: 0;
    bottom: -12px;
    left: 50%;
    margin-left: -6px;
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.guide {
    animation: fadeInDown 0.5s ease-in-out;
}

.map-button {
    position: absolute;
    transform: translate(-50%, -50%);
}

.start-point {
    background-color: #007fff;
    border: 2px solid #ffffff;
    opacity: 0.9;
    pointer-events: none;
    color: #ffffff;
}

.btn-trans-from {
    background-color: #6d00bc;
    border: 2px solid #ffffff;
    opacity: 0.9;
    pointer-events: none;
    color: #ffffff;
    border-radius: 9999px;
    padding: 2px;
}

.btn-trans-to {
    background-color: #161616;
    border: 2px solid #ffffff;
    opacity: 0.9;
    pointer-events: none;
    color: #ffffff;
    border-radius: 9999px;
    padding: 2px;
}

.end-point {
    background-color: #ff007f;
    border: 2px solid #ffffff;
    opacity: 0.9;
    pointer-events: none;
    color: #ffffff;
}

.rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
}

.rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}
</style>